import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Styled Components"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "styled-components"
    }}>{`Styled Components`}</h1>
    <p>{`Theme UI itself doesn’t expose an API for styled components, but works
seamlessly with the `}<inlineCode parentName="p">{`styled`}</inlineCode>{` API from the `}<a parentName="p" {...{
        "href": "https://emotion.sh/docs/styled"
      }}>{`@emotion/styled`}</a>{` package.
Components written with it should have access to the same theming context that
Theme UI uses.`}</p>
    <p>{`Instead of using the `}<inlineCode parentName="p">{`ThemeProvider`}</inlineCode>{` component from `}<inlineCode parentName="p">{`@emotion/react`}</inlineCode>{`, import and
use the Theme UI provider at your app’s root level.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`/** @jsxImportSource theme-ui */
import { ThemeProvider } from 'theme-ui'
import theme from './theme'
import SomeComponent from './SomeComponent'

export default (props) => (
  <ThemeProvider theme={theme}>
    <SomeComponent />
  </ThemeProvider>
)
`}</code></pre>
    <p>{`If you’re using the `}<a parentName="p" {...{
        "href": "https://styled-components.com"
      }}>{`Styled Components`}</a>{` library, these can usually be
converted to use Emotion with a single line change to the `}<inlineCode parentName="p">{`import`}</inlineCode>{` statement.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// before
import styled from 'styled-components'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// after
import styled from '@emotion/styled'
`}</code></pre>
    <h2 {...{
      "id": "using-the-sx-prop"
    }}>{`Using the `}<inlineCode parentName="h2">{`sx`}</inlineCode>{` prop`}</h2>
    <p>{`Theme UI is actively working on removing its internal dependency on
`}<inlineCode parentName="p">{`@emotion/styled`}</inlineCode>{` to reduce bundle size. While Styled Components made with the
package will continue to work into the future, we recommend using the
`}<a parentName="p" {...{
        "href": "/sx-prop"
      }}><inlineCode parentName="a">{`sx`}</inlineCode>{` prop`}</a>{` instead for simpler styling with
`}<a parentName="p" {...{
        "href": "/guides/object-styles"
      }}>{`object styles`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`/** @jsxImportSource theme-ui */

const Section = ({ width, color, bg, ...props }) => (
  <section
    {...props}
    sx={{
      width,
      color,
      bg,
      // additional styles...
    }}
  />
)
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      